module.exports = __webpack_public_path__ + "img/20170820_075918-min.338bf5bd.jpg";